// libs
import React from "react";

// defs
import { SEVERITY } from "@defs/Severity";

// components
import { Alert as MuiAlert, AlertProps, AlertTitle, Button } from "@mui/material";

// props
export interface IAlertProps {
    title: string;
    content?: string;
    severity: SEVERITY;
    isDismissible?: boolean;
    enableRefreshCTA?: boolean;
}

const Alert: React.FC<IAlertProps> = ({ title, severity, content, isDismissible, enableRefreshCTA }) => {
    const onRefresh = (): void => {
        if (window?.location) {
            window.location.reload();
        }
    };
    if (isDismissible) return <></>;

    const alertProps: AlertProps = {
        severity: severity,
    };

    if (enableRefreshCTA) {
        alertProps.action = (
            <Button color="inherit" size="small" onClick={onRefresh}>
                Refresh
            </Button>
        );
    }

    return (
        <MuiAlert {...alertProps} sx={{ position: "absolute", width: "calc(100% - 8px)", zIndex: 10 }}>
            <AlertTitle>{title}</AlertTitle>
            {content ?? ""}
        </MuiAlert>
    );
};

export default React.memo(Alert);
